import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

// --- CONFIGURAÇÕES GLOBAIS ---
const API_URL = 'https://newsletter.dizycommerce.com.br/api';
const getToken = () => sessionStorage.getItem('jwtToken');

const Dashboard = () => {
  const navigate = useNavigate();
  
  // 1. Estados
  const [stores, setStores] = useState([]); 
  const [newStoreName, setNewStoreName] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false); // ESTADO PARA ADMIN
  
  // Estados para o Modal de Gerenciamento
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const [templates, setTemplates] = useState([]);

  // 2. Busca inicial e Verificação de Perfil
  useEffect(() => {
    fetchStores();
    
    // VERIFICA SE É ADMIN
    const loggedUser = JSON.parse(sessionStorage.getItem('user'));
    if (loggedUser && loggedUser.role === 'admin') {
      setIsAdmin(true);
    }
  }, []);

  const fetchStores = async () => {
    try {
      const token = getToken();
      const response = await axios.get(`${API_URL}/lojas`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      setStores(response.data); 
    } catch (error) {
      console.error("Erro ao buscar:", error.response?.data || error.message);
    }
  };

  const deleteStore = async (id, nome) => {
    if (window.confirm(`Deseja excluir a loja ${nome}?`)) {
      try {
        const token = getToken();
        await axios.delete(`${API_URL}/lojas/${id}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        setStores(prev => prev.filter(loja => loja.id !== id));
        alert("Loja removida!");
      } catch (error) {
        alert("Não foi possível excluir.");
      }
    }
  };

  const handleManageTemplates = async (store) => {
    setSelectedStore(store);
    try {
      const response = await axios.get(`${API_URL}/lojas/${store.id}`);
      setTemplates(response.data.templates || []);
      setIsModalOpen(true);
    } catch (error) {
      alert("Erro ao carregar templates.");
    }
  };

  const addStore = async (e) => {
    e.preventDefault();
    if (!newStoreName) return;
    try {
      const token = getToken();
      await axios.post(`${API_URL}/lojas`, 
        { name: newStoreName },
        { headers: { 'Authorization': `Bearer ${token}` }}
      );
      fetchStores();
      setNewStoreName('');
      setShowAddForm(false);
    } catch (error) {
      alert("Erro ao salvar loja.");
    }
  };

  const handleAction = (store) => {
    const nomeOriginal = store.nome || store.name || "Loja";
    const nomeFormatado = nomeOriginal.replace(/\s+/g, '_');
    const hasTemplate = store.template_id !== null;

    if (hasTemplate) {
      window.location.href = `/editor.html?id=${store.id}&nome=${nomeFormatado}`;
    } else {
      navigate(`/registrar-template?id=${store.id}&nome=${nomeFormatado}`);
    }
  };

  const handleLogout = () => {
    sessionStorage.clear(); 
    navigate('/');
  };

  return (
    <div style={styles.appLayout}>
      {/* SIDEBAR */}
      <nav 
        style={{ ...styles.sidebar, width: isExpanded ? '250px' : '70px' }}
        onMouseEnter={() => setIsExpanded(true)}
        onMouseLeave={() => setIsExpanded(false)}
      >
        <div style={styles.logoArea}>
          <h2 style={styles.logoText}>{isExpanded ? 'Newsletter 2.0' : 'N2'}</h2>
        </div>
        <ul style={styles.menuList}>
          <li style={styles.menuItem} onClick={() => setShowAddForm(!showAddForm)}>
            <span style={styles.icon}>➕</span>
            {isExpanded && <span>Nova Loja</span>}
          </li>
          <li style={styles.menuItem} onClick={() => navigate('/pdf')}>
            <span style={styles.icon}>📄</span>
            {isExpanded && <span>Gerar PDF</span>}
          </li>
          <li style={styles.menuItem} onClick={() => navigate('/utm')}>
            <span style={styles.icon}>🔗</span>
            {isExpanded && <span>Links UTM</span>}
          </li>
        </ul>
        <button onClick={handleLogout} style={styles.sidebarLogoutBtn}>
          {isExpanded ? 'Sair 👋' : '🚪'}
        </button>
      </nav>

      {/* CONTEÚDO PRINCIPAL */}
      <main style={styles.mainContent}>
        {/* HEADER ATUALIZADO COM BOTÃO ADMIN À DIREITA */}
        <header style={styles.header}>
          <h1>Painel de Lojas</h1>
          
          <div style={styles.topActions}>
            {isAdmin && (
              <button 
                onClick={() => navigate('/admin')} 
                style={styles.adminBtn}
              >
                ⚙️ Gerenciar Usuários
              </button>
            )}
          </div>
        </header>

        {showAddForm && (
          <div style={styles.addCard}>
            <input 
              style={styles.input}
              placeholder="Nome da Loja"
              value={newStoreName}
              onChange={(e) => setNewStoreName(e.target.value)}
            />
            <button onClick={addStore} style={styles.saveBtn}>Criar Loja</button>
          </div>
        )}

        <div style={styles.grid}>
          {stores.map((store) => (
            <div key={store.id} style={styles.storeCard}>
              <div onClick={() => handleAction(store)}>
                <div style={styles.storeIcon}>🏪</div>
                <h3 style={styles.storeName}>{store.name}</h3>
              </div>

              <div style={styles.actionContainer}>
                <button onClick={() => handleManageTemplates(store)} style={styles.btnManage}>
                  ⚙️ Gerenciar
                </button>
                <button onClick={() => deleteStore(store.id, store.name)} style={styles.btnDelete}>
                  🗑️ Excluir
                </button>
              </div>
            </div>
          ))}
        </div>
      </main>

      {/* MODAL DE TEMPLATES */}
      {isModalOpen && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h2>Templates: {selectedStore?.name}</h2>
            <button style={styles.saveBtn} onClick={() => navigate(`/registrar-template?id=${selectedStore.id}`)}>
              + Adicionar Novo Template
            </button>
            <hr />
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {templates.map(t => (
                <li key={t.id} style={styles.templateItem}>
                  <span>{t.nome || "Template Principal"}</span>
                  <button style={styles.btnEdit} onClick={() => navigate(`/editar-base/${t.id}`)}>Editar HTML</button>
                </li>
              ))}
            </ul>
            <button onClick={() => setIsModalOpen(false)} style={styles.closeBtn}>Fechar</button>
          </div>
        </div>
      )}
    </div>
  );
};

// --- ESTILOS ATUALIZADOS ---
const styles = {
  appLayout: { display: 'flex', height: '100vh', fontFamily: 'sans-serif' },
  sidebar: { backgroundColor: '#2c3e50', color: 'white', display: 'flex', flexDirection: 'column', padding: '20px 10px', transition: 'width 0.3s ease', overflow: 'hidden', whiteSpace: 'nowrap', zIndex: 100 },
  logoArea: { marginBottom: '40px', textAlign: 'center', borderBottom: '1px solid #34495e', paddingBottom: '10px' },
  logoText: { fontSize: '18px', color: '#ecf0f1', margin: 0 },
  menuList: { listStyle: 'none', padding: 0, flexGrow: 1 },
  menuItem: { display: 'flex', alignItems: 'center', padding: '15px 10px', cursor: 'pointer', borderRadius: '8px', marginBottom: '5px' },
  icon: { fontSize: '20px', marginRight: '15px' },
  sidebarLogoutBtn: { backgroundColor: '#e74c3c', color: 'white', border: 'none', padding: '12px', borderRadius: '8px', cursor: 'pointer', width: '100%' },
  
  mainContent: { flexGrow: 1, padding: '30px', backgroundColor: '#f4f7f6', overflowY: 'auto' },
  
  // HEADER AJUSTADO
  header: { 
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center', 
    marginBottom: '30px',
    paddingBottom: '10px',
    borderBottom: '1px solid #ddd'
  },
  topActions: { display: 'flex', gap: '15px', alignItems: 'center' },
  adminBtn: { 
    backgroundColor: '#8e44ad', 
    color: 'white', 
    border: 'none', 
    padding: '10px 18px', 
    borderRadius: '8px', 
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '14px',
    boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
  },
  logoutBtn: { 
    backgroundColor: '#fff', 
    color: '#333', 
    border: '1px solid #ddd', 
    padding: '10px 18px', 
    borderRadius: '8px', 
    cursor: 'pointer',
    fontSize: '14px' 
  },

  addCard: { backgroundColor: 'white', padding: '20px', borderRadius: '10px', marginBottom: '30px', display: 'flex', gap: '10px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  input: { padding: '10px', borderRadius: '5px', border: '1px solid #ddd', flex: 1 },
  saveBtn: { padding: '10px 20px', backgroundColor: '#27ae60', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '20px' },
  storeCard: { backgroundColor: 'white', padding: '20px', borderRadius: '12px', textAlign: 'center', boxShadow: '0 2px 5px rgba(0,0,0,0.05)', transition: 'transform 0.2s' },
  storeIcon: { fontSize: '40px', marginBottom: '10px', cursor: 'pointer' },
  storeName: { margin: '10px 0', fontSize: '18px', cursor: 'pointer' },
  actionContainer: { display: 'flex', gap: '10px', marginTop: '15px' },
  btnManage: { flex: 1, padding: '8px', backgroundColor: '#3498db', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '12px' },
  btnDelete: { flex: 1, padding: '8px', backgroundColor: '#e74c3c', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '12px' },
  
  modalOverlay: { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
  modalContent: { backgroundColor: 'white', padding: '30px', borderRadius: '10px', width: '400px', textAlign: 'center' },
  templateItem: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', borderBottom: '1px solid #eee' },
  btnEdit: { padding: '5px 10px', backgroundColor: '#f39c12', color: 'white', border: 'none', borderRadius: '3px', cursor: 'pointer' },
  closeBtn: { marginTop: '20px', padding: '10px 20px', backgroundColor: '#95a5a6', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer' }
};

export default Dashboard;
